import { render, staticRenderFns } from "./crudSellers.vue?vue&type=template&id=2c926776&scoped=true&"
import script from "./crudSellers.vue?vue&type=script&lang=js&"
export * from "./crudSellers.vue?vue&type=script&lang=js&"
import style0 from "./crudSellers.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudSellers.vue?vue&type=style&index=1&id=2c926776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c926776",
  null
  
)

export default component.exports